import {capitalizeFirstLetter, endpoints} from "../../../utils2";
import {useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson} from "../../../hooks";
import {Alert} from "react-bootstrap";

export function RenderDailyShort({config1, textStyle = "fw-light"}) {

    const orderMap = {
        monday: 0,
        tuesday: 1,
        wednesday: 2,
        thursday: 3,
        friday: 4,
        saturday: 5,
        sunday: 6
    };

    // Sort using the reference
    const sortedDays = config1.daily.sort((a, b) => orderMap[a.toLowerCase()] - orderMap[b.toLowerCase()]);

    const shortDays = sortedDays.map(item =>
        capitalizeFirstLetter(item).slice(0, 3)
    )
    return <div className={textStyle}>{shortDays.join(", ")}</div>
}

export function RenderControlledBy({config1}) {
    const {uid} = useParams()
    const {authToken} = useAuth()

    const [dev, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, config1?.controlled_by_id), authToken?.jwt)
    const deviceName = dev?.data.name

    return <>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>

        <div className="fw-light">{deviceName}</div>
    </>
}
